<template>
  <div class="relative w-full">
    <div class="flex gap-2">
      <Input
        :placeholder="placeholder"
        class="w-full"
        v-model="modelValueLocal"
        @focus="$emit('focus')"
      />
    </div>

    <div
      v-if="props.openMenu && props.items.length"
      class="absolute z-50 max-h-60 w-full overflow-auto rounded border bg-white shadow-md mt-2"
    >
      <div
        v-for="item in props.items"
        :key="item.id"
        class="hover:bg-primary-400 cursor-pointer px-2 py-1 hover:text-black dark:text-black"
        @click="$emit('select', item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import Input from '~/components/ui/input/index.vue'
  import { ref, watch } from 'vue'
  import { useDebounce } from '@vueuse/core'

  const { t } = useI18n()

  const props = defineProps<{
    modelValue: string
    items: any[]
    isDirty: boolean
    openMenu: boolean
    debounceTime?: number
    placeholder?: string
  }>()

  const emit = defineEmits(['update:modelValue', 'focus', 'save', 'select'])

  const modelValueLocal = ref(props.modelValue)

  const debouncedModel = useDebounce(modelValueLocal, props.debounceTime ?? 500)

  watch(debouncedModel, (val) => emit('update:modelValue', val))

  watch(
    () => props.modelValue,
    (val) => (modelValueLocal.value = val)
  )
</script>
